
import { defineComponent, reactive} from "vue";
import {useRoute, useRouter} from "vue-router";
interface State {
    renderTxt: string;
}
    export default defineComponent({
        name: "deffectiveReport",
        setup() {
            let state: State = reactive({
               renderTxt: '',
           })
            const {query} = useRoute();
            const {lang} = query;
            switch (lang) {
                case 'en':
                    state.renderTxt = 'Sorry, this report is no longer valid';
                    break;
                case 'ru':
                    state.renderTxt = 'Извините, данный отчет больше не действителен';
                    break;
                default:
                    state.renderTxt = '抱歉，当前报告已失效';
                    break;
            }
            return {
               state
           }
        },
        methods: {
            goBack(){
                // history.go(-1)
                if (history.length > 1) {
                    history.go(-1)
                } else {
                    window.opener = null;
                    window.open("about:blank", "_self");
                    window.close();
                }
            }
        }
    });
